<template>
  <div>
    <div style="margin-top:30px;">
      <div>
        <div class="md:float-left mt-5">
          <input type="button" class="chooseOptionButton" id="button_filter_pending_request" value="Solicitudes Pendientes" style=""
          v-bind:style="{
            backgroundColor: statusFilter == statusToFilterInPendingButton ? activeColorBackground : inactiveColorBackground, 
            color: statusFilter == statusToFilterInPendingButton ? activeColorText : inactiveColorText,
            borderColor: statusFilter == statusToFilterInPendingButton ? activeBorderColor : inactiveBorderColor
          }"
          v-on:click="filterByStatus(statusToFilterInPendingButton)"/>
        </div>
        <div class="md:float-left md:ml-5 mt-5">
          <input type="button" class="chooseOptionButton" id="button_filter_accepted_request" value="Solicitudes Aceptadas" style=""
          v-bind:style="{
            backgroundColor: statusFilter == statusToFilterInAcceptedButton ? activeColorBackground : inactiveColorBackground, 
            color: statusFilter == statusToFilterInAcceptedButton ? activeColorText : inactiveColorText,
            borderColor: statusFilter == statusToFilterInAcceptedButton ? activeBorderColor : inactiveBorderColor
          }"
          v-on:click="filterByStatus(statusToFilterInAcceptedButton)"/>
        </div>
        <div class="md:float-left md:ml-5 mt-5">
          <input type="button" class="chooseOptionButton" id="button_filter_rejected_request" value="Solicitudes Rechazadas" style=""
          v-bind:style="{
            backgroundColor: statusFilter == statusToFilterInRejectedButton ? activeColorBackground : inactiveColorBackground, 
            color: statusFilter == statusToFilterInRejectedButton ? activeColorText : inactiveColorText,
            borderColor: statusFilter == statusToFilterInRejectedButton ? activeBorderColor : inactiveBorderColor
          }"
          v-on:click="filterByStatus(statusToFilterInRejectedButton)"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { filterByStatus } from '@/helpers/tablePagination'
import('@/assets/css/stylesheet.css')

export default {
  data() {
    return {
      statusFilter: '',
      activeColorBackground: '#198F99',
      inactiveColorBackground: '#FFF',
      activeColorText: '#FFF',
      inactiveColorText: '#6B6969',
      activeBorderColor: "#198F99",
      inactiveBorderColor: "#6B6969",
      response: {
        status: false,
        data: {}
      },
    }
  },
  props: {
    list_to_filter: {
      type: Array,
      default: []
    },
    statusToFilterInPendingButton: {
      type: String,
      default: 'pendiente'
    },
    statusToFilterInAcceptedButton: {
      type: String,
      default: 'aceptado'
    },
    statusToFilterInRejectedButton: {
      type: String,
      default: 'rechazado'
    }
  },
  name: 'FilterButtonsComponents',
  mounted() {
    this.statusFilter = this.statusToFilterInPendingButton;
  },
  methods: {
    filterByStatus(status) {
      this.statusFilter = status;
      if (this.list_to_filter.length > 0) {
        let listFilteredByStatus = filterByStatus(this.list_to_filter, 'status', this.statusFilter);

        this.response.status = status;
        this.response.data = listFilteredByStatus;
        this.$emit('filter-list-by-status', this.response);
      }
    }
  }
}
</script>